import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import authRoutes from '../routes/authroutes.js';

const GOOGLE_RECAPTCHA_SITE_KEY = process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY;

class Blanklayout extends React.Component {
  render() {
    return (
      <GoogleReCaptchaProvider
        reCaptchaKey={GOOGLE_RECAPTCHA_SITE_KEY}
        useRecaptchaNet={true}
        scriptProps={{
          async: true,
          defer: true,
        }}
        container={{
          element: "recaptcha-container",
          parameters: {
          badge: "bottomright",
          theme: "light",
          }
        }}
      >
        <div className="authentications">
          <Switch>
            {authRoutes.map((prop, key) => {
              if (prop.redirect) {
                return (
                  <Redirect from={prop.path} to={prop.pathTo} key={key} />
                );
              }
              return (
                <Route path={prop.path} component={prop.component} key={key} />
              );
            })}
          </Switch>
        </div>
        <div id="recaptcha-container"></div>
      </GoogleReCaptchaProvider>
    );
  }
}

export default Blanklayout;